import { Helmet } from 'react-helmet';
import {
    Box,
    Typography,
    TextField
} from '@mui/material';
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import { ReactComponent as AddRow } from "../../../../assets/icons/addRow.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as Megaphone } from "../../../../assets/images/megaphone.svg";
import { useParams } from "react-router-dom";
import { useFormik, Formik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import emty from "../../../../assets/images/emty.png";

const styles = {
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "justify-content": "center",
        "align-items": "center",
        marginBottom: "30px"
    },
};
const CommentTab = (props) => {
    const _ = require('lodash');
    let { loRow, value, statusEdit, callBack, editor, submitError, actSave, checkeNextAction, instruction } = props
    const { t, i18n } = useTranslation();
    const [individual, setIndividual] = React.useState({ detail: [], });
    const [update, setUpdate] = React.useState(false);
    const [dataErrorFormik, setdataErrorFormik] = React.useState({});
    const validationSchema = yup.object(dataErrorFormik);
    const formik = useFormik({
        initialValues: {
            detail: {},
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            // submit(values)
        },
    });

    useEffect(() => {
        if (statusEdit === false) {
            setIndividual({ detail: [] })
        } else {
            let selectData = {}
            if (loRow.type === "comment") {
                let detail = []
                let evaluator = []
                if (loRow?.list_item !== undefined && loRow?.list_item.length > 0) {
                    for (let id = 0; id <= loRow?.list_item.length - 1; id++) {
                        detail.push({
                            question_id: loRow?.list_item[id]?.question_id,
                            serial: loRow?.list_item[id]?.serial,
                            topic: loRow?.list_item[id]?.topic,
                            is_required: loRow?.list_item[id]?.is_required,
                            comment: loRow?.list_item[id]?.comment
                        })
                    }
                }
                if (loRow?.list_item !== undefined && loRow?.list_item.length > 0) {
                    for (let id = 0; id <= loRow?.list_item.length - 1; id++) {
                        evaluator.push({
                            question_id: loRow?.list_item[id]?.question_id,
                            serial: loRow?.list_item[id]?.serial,
                            topic: loRow?.list_item[id]?.topic,
                            is_required: loRow?.list_item[id]?.is_required,
                            comment: loRow?.list_item[id]?.comment
                        })
                    }
                }
                selectData.detail = detail
                selectData.evaluator = evaluator
            }
            formik.setFieldValue("detail", selectData.detail)
            formik.setFieldValue("evaluator", selectData.evaluator)
            setIndividual(selectData);
        }
    }, [statusEdit]);

    const changeDataComment = async (index, data) => {
        let oData = individual
        let chData = oData.evaluator
        chData[index].comment = data
        formik.setFieldValue("evaluator", chData)
        callBack(formik.values, "evaluate_comment");
    };
    return (
        <Box sx={{ display: value === `comment` ? 'block' : 'none' }}>
            <Typography fontSize={24} fontWeight={500} lineHeight="35.88px" color="#404349" sx={{ "text-transform": "capitalize" }} >{t('360Evaluation.label.comment')}</Typography>
            {Util.formatData(instruction, false) !== false ?
                <Box pt="30px">
                    <Box sx={{ background: "#EFF6F4", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", padding: "15px" }}>
                        <Megaphone></Megaphone>
                        <Typography fontSize={18} lineHeight="19.8px" color="#5DA196" pl="10px" dangerouslySetInnerHTML={{ __html: instruction }}>
                        </Typography>
                    </Box>
                </Box>
                : null}
            <Box mt="30px" mb="30px" sx={{ display: value === loRow.type ? 'block' : 'none', padding: "30px", background: "#FFFFFF", border: "1px solid #E4E4E4", "box-sizing": "border-box", "border-radius": "10px" }}>
                <Box>
                    {statusEdit === false && loRow?.list_item !== undefined && loRow?.list_item.length > 0 ?
                        loRow?.list_item.map((rs, index) => (
                            <Box display="flex" pd="25px" sx={{ "flex-flow": "row wrap" }}>
                                <Box width="100%">
                                    <Box display="flex">
                                        <Box width="35px">
                                            <Typography fontSize={18} lineHeight="26.91px" fontWeight="600" color="#404349" pb="15px">
                                                Q{index + 1}:
                                            </Typography>
                                        </Box>
                                        <Box width="calc(100% - 35px)" pl="5px">
                                            <Typography fontSize={18} lineHeight="26.91px" fontWeight="600" color="#404349" pb="15px">
                                                {rs.topic}  {rs?.is_required ? <span style={{ color: "#CC6058 " }}>*</span> : ""}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box mb="25px">
                                        <Typography pl="45px" sx={{ wordBreak: "break-all" }} fontSize={rs?.comment === "" ? "18px" : "16px"} lineHeight={rs?.comment === "" ? "26.91px" : "24px"} fontWeight="400" color={rs?.comment === "" ? "#C4C4C4" : "#404349"}>
                                            {rs?.comment !== "" && rs?.comment !== undefined ? rs?.comment : t('evaluation.notCommentedYet')}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        ))
                        : individual.detail !== undefined && individual.detail.length > 0 ?
                            statusEdit === true ?
                                individual.evaluator.map((rs, index) =>
                                    <Box display="flex" pd="25px" sx={{ "flex-flow": "row wrap" }}>
                                        <Box width="100%">
                                            <Box display="flex">
                                                <Box width="35px">
                                                    <Typography fontSize={18} lineHeight="26.91px" fontWeight="600" color="#404349" pb="15px">
                                                        Q{index + 1}:
                                                    </Typography>
                                                </Box>
                                                <Box width="calc(100% - 35px)" pl="5px">
                                                    <Typography fontSize={18} lineHeight="26.91px" fontWeight="600" color="#404349" pb="15px">
                                                        {rs.topic} {rs?.is_required ? <span style={{ color: "#CC6058 " }}>*</span> : ""}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box mb="25px" sx={{
                                                ".MuiFormHelperText-root": {
                                                    color: " #CC6058 !important",
                                                    fontSize: "14px",
                                                    lineHeight: "15.4px",
                                                    // marginLeft: 0,
                                                    // position: "absolute",
                                                    // bottom: "-22px",
                                                },
                                                ".MuiOutlinedInput-notchedOutline": {
                                                    "border-color": rs?.is_required && actSave && formik.values?.evaluator[index]?.comment.length === 0 ? "#CC6058 !important" : ""
                                                }
                                            }}>
                                                <TextField
                                                    margin="dense"
                                                    multiline
                                                    placeholder={t('label.fillYourFeedback')}
                                                    // id="field_9"
                                                    fullWidth
                                                    size="small"
                                                    // disabled={comment.edit === false ? true : false}
                                                    maxRows={4}
                                                    minRows={4}
                                                    sx={{ marginTop: "0px", marginBottom: 0, height: "100%", ".MuiOutlinedInput-root": { height: "100%", "align-items": "flex-start" } }}
                                                    value={formik.values?.evaluator[index]?.comment}
                                                    onChange={(newValue) => {
                                                        changeDataComment(index, newValue.target.value);
                                                    }}
                                                    helperText={rs?.is_required && actSave && formik.values?.evaluator[index]?.comment.length === 0 ? t('label.pleaseFillOutThisField') : ""}
                                                    error={rs?.is_required && actSave && formik.values?.evaluator[index]?.comment.length === 0}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                )
                                :
                                loRow?.list_item.map((rs, index) => (
                                    <Box display="flex" pd="25px" sx={{ "flex-flow": "row wrap" }}>
                                        <Box width="100%">
                                            <Box display="flex">
                                                <Box width="35px">
                                                    <Typography fontSize={18} lineHeight="26.91px" fontWeight="600" color="#404349" pb="15px">
                                                        Q{index + 1}:
                                                    </Typography>
                                                </Box>
                                                <Box width="calc(100% - 35px)" pl="10px">
                                                    <Typography fontSize={18} lineHeight="26.91px" fontWeight="600" color="#404349" pb="15px">
                                                        {rs.topic} {rs?.is_required ? <span style={{ color: "#CC6058 " }}>*</span> : ""}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box mb="25px">
                                                {editor === "self" && checkeNextAction?.options?.hide_score_self === true ?
                                                    <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", }} fontSize="18px" lineHeight="26.91px" fontWeight="400" color="#C4C4C4">
                                                        {t('evaluation.notEvaluatedYet')}
                                                    </Typography>
                                                    :
                                                    <Typography pl="45px" sx={{ wordBreak: "break-all" }} fontSize={rs?.comment === "" ? "18px" : "16px"} lineHeight={rs?.comment === "" ? "27px" : "24px"} fontWeight="400" color={rs?.comment === "" ? "#C4C4C4" : "#404349"}>
                                                        {rs?.comment !== "" && rs?.comment !== undefined ? rs?.comment : t('evaluation.notCommentedYet')}
                                                    </Typography>
                                                }
                                            </Box>
                                        </Box>
                                    </Box>
                                ))
                            :
                            null
                        // <Box item sx={styles.emty} >
                        //     <img src={emty} alt="emtyData"></img>
                        //     <Typography pt={1} fontSize={16} fontWeight="fontWeightLight" variant="label">Your evaluation has not been assigned yet.</Typography>
                        // </Box>
                    }
                </Box>
            </Box>
        </Box>
    )
};
export default CommentTab;
